import { nanoid } from 'nanoid'
import { forwardRef, useMemo } from 'react'

import { DirtyFormTracking } from 'components/core/form'
import changeSet from 'core/change_set'

import { Footer } from './footer'
import { useGoBack } from '../../use_go_back'
import { EditingRestricted } from '../components/editing_restricted'
import { FormBody, StyledForm, Wrapper } from '../styles'
import { ValidationErrorAlert } from '../validation_error_alert'

export const BaseSection = forwardRef(({
  children,
  etLocked,
  externalError,
  formatValues = (v) => v,
  initialValues = {},
  isManaged = false,
  saveDisabled,
  skipDirtyCheck = false,
  validationSchema,
  onSubmit,
  ...rest
}, ref) => {
  const goBack = useGoBack()
  const formId = useMemo(() => nanoid(), [])

  const handleSubmit = (values, actions) => {
    if (!onSubmit) { return goBack() }

    if (!skipDirtyCheck && !changeSet.isDirty(formId)) {
      return goBack()
    }

    return onSubmit(formatValues(values), actions)
  }

  return (
    <Wrapper ref={ref} {...rest}>
      <StyledForm
        externalError={externalError}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {etLocked && <EditingRestricted lockingDisables />}
        <DirtyFormTracking formId={formId} />
        <ValidationErrorAlert />
        <FormBody>
          {children}
        </FormBody>
        <Footer
          isManaged={isManaged}
          saveDisabled={saveDisabled}
          onCancel={goBack}
        />
      </StyledForm>
    </Wrapper>
  )
})
